require('./components/vacationSearchDealPromoBoxComponent.js');
require('./components/vacationSearchLdJsonComponent.js');
require('./components/vacationSearchLocationComponent.js');
require('./components/vacationSearchReviewsComponent.js');

const vacationSearchService = require('../components/vacationSearch/vacationSearchService.js');
const favorites = require('../components/favorites/favorites.js');
const monthYearPicker = require('../components/monthYearPicker/monthYearPicker.js');
const fancyBoxBySize = require('../components/fancyBoxBySize/fancyBoxBySize.js');
const countdownTimer = require('../components/countdownTimer/countdownTimer.js');

(function ($) {
    $(document).ready(function () {
        var dealPromoBoxes = Object.assign({}, window.vacationSearchDealPromoBoxes);
        if (!dealPromoBoxes.hasOwnProperty('startAt')) dealPromoBoxes.startAt = 4;
        if (!dealPromoBoxes.hasOwnProperty('repeatAfter')) dealPromoBoxes.repeatAfter = 3;
        if (!dealPromoBoxes.boxes) dealPromoBoxes.boxes = [];
        var filteredRegions = {};
        var destIds = (window.vacationSearchParameters || { w: [] }).w || [];
        var hasMc = (window.vacationSearchParameters || { mc: false }).mc || false;
        $('input.region-input').each((idx, elem) => { var e = $(elem); var regionId = 'r' + e.val(); filteredRegions[regionId] = false; });
        $('input[data-related-region]').each((idx, elem) => { var e = $(elem); if ((elem.name === 'w' && destIds.indexOf(e.val()) >= 0) || (elem.name === 'mc' && hasMc)) filteredRegions['r' + e.attr('data-related-region')] = true; });

        window.vacationSearchVue = new Vue({
            el: '#vacationSearchApp',
            data: {
                vacations: [],
                initialized: false,
                loading: true,
                dirty: false,
                sortOrder: '',
                daysToDrop: 0,
                yearMonthOptions: {},
                currentYear: new Date().getFullYear(),
                currentMonth: new Date().getMonth(),
                visibleYear: new Date().getFullYear(),
                pageSize: 24,
                pages: 1,
                vacationsPerRow: 3,
                dealPromoBoxes,
                filteredRegions,
                // deep copy, so we can compare it to the base later
                filterParams: JSON.parse(JSON.stringify(window.vacationSearchParameters || {}))
            },
            computed: {
                sortedVacations: function () {
                    var sortedVacations = [];
                    switch (this.sortOrder) {
                        case 'highestRated':
                            var intermediateSortedVacations = _.sortBy(this.vacations, function (v) {
                                return v.reviews && v.reviews.value && v.reviews.value.totalReviews ? v.reviews.value.totalReviews : 0;
                            });
                            sortedVacations = _.sortBy(intermediateSortedVacations, function (v) {
                                return v.reviews && v.reviews.value && v.reviews.value.averageRating ? Math.round(v.reviews.value.averageRating * 2) / 2 : 0;
                            }).reverse();
                            break;
                        case 'departureDate':
                            sortedVacations = _.sortBy(this.vacations, (vac) => vac.pricingSummary.departureDate);
                            break;
                        case 'lowestPrice':
                            sortedVacations = _.sortBy(this.vacations, (vac) => vac.pricingSummary.leadPrice);
                            break;
                        case 'shortestDuration':
                            sortedVacations = _.sortBy(this.vacations, (vac) => vac.summaryStrip.value.duration);
                            break;
                        case 'longestDuration':
                            sortedVacations = _.sortBy(this.vacations, (vac) => vac.summaryStrip.value.duration).reverse();
                            break;
                        default: // alphabetical
                            sortedVacations = _.sortBy(this.vacations, 'name');
                    }

                    return sortedVacations;
                },
                visibleVacations: function () {
                    return _.first(this.sortedVacations, this.numVacationsToShow);
                },
                vacationCount: function () {
                    return this.initialized ? this.vacations.length : -1;
                },
                visibleVacationCount: function () {
                    return this.initialized ? this.visibleVacations.length : -1;
                },
                enableShowMore: function () {
                    return this.initialized && !this.loading && this.vacations.length > this.visibleVacations.length;
                },
                hasGreaterYear: function () { return this.years.indexOf(this.visibleYear + 1) >= 0; },
                hasLesserYear: function () { return this.years.indexOf(this.visibleYear - 1) >= 0; },
                extraBoxes: function () {
                    var boxes = [], visible = this.visibleVacationCount;
                    if (this.vacationsPerRow === 1 || visible <= 0) return boxes;
                    var extraNeeded = this.vacationsPerRow - (visible % this.vacationsPerRow);
                    if (extraNeeded === this.vacationsPerRow) return boxes;

                    for (var i = 0; i < extraNeeded; i++) boxes.push(i);

                    return boxes;
                },
                years: function () {
                    let yearStrings = Object.keys(this.yearMonthOptions).sort(function (a, b) {
                        return a - b;
                    });
                    return _.map(yearStrings, (y) => parseInt(y));
                },
                numVacationsToShow: function () {
                    if (!this.dealPromoBoxes.boxes || this.dealPromoBoxes.boxes.length === 0) {
                        // if there are no deal promos, this is a simple calculation
                        return this.pages * this.pageSize
                    }

                    // We want to select out results so that the <# of results> + <# of deal promos> == desired page size
                    // Note that the key to this calculation is that the <# of deal promos> can be determined by
                    // calculating the # of full groups of size <repeat after> that go into our desired page size
                    let adjustedPageSize = this.pages * this.pageSize - this.dealPromoBoxes.startAt;
                    let dealPromosInRequest = Math.ceil(adjustedPageSize / (this.dealPromoBoxes.repeatAfter + 1));
                    if ((adjustedPageSize - 1) % (this.dealPromoBoxes.repeatAfter + 1) == 0) {
                        // adjust for an off-by-one error when the adjusted page size is divisible by the sum of the repeatAfter value + 1 for the box
                        // NOTE: This isn't helping totally because we only display promo boxes BEFORE vacation search results
                        dealPromoBoxes++;
                    }
                    return this.pages * this.pageSize - dealPromosInRequest;
                },
                isFiltered: function () {
                    if (this.filterParams.w && this.filterParams.w.length > 0) { // destinations
                        return true;
                    }
                    if (this.filterParams.o && this.filterParams.o.length > 0) { // operators
                        return true;
                    }
                    if (this.filterParams.m && this.filterParams.m.length > 0) { // months
                        return true;
                    }
                    if (this.filterParams.d && this.filterParams.d.length > 0) { // durations
                        return true;
                    }
                    if (this.filterParams.c && this.filterParams.c.length > 0) { // price ranges
                        return true;
                    }
                    if (this.filterParams.t && this.filterParams.t.length > 0) { // travel type
                        return true;
                    }
                    if (this.filterParams.s && this.filterParams.s.length > 0) { // style
                        return true;
                    }
                    if (this.filterParams.p && this.filterParams.p.length > 0) { // pace
                        return true;
                    }
                    if (this.filterParams.r && this.filterParams.r.length > 0) { // river
                        return true;
                    }
                    if (this.filterParams.sp || this.filterParams.n || this.filterParams.mc) { // flags
                        return true;
                    }

                    return false;
                }
            },
            filters: {
                currency: function (value) {
                    if (typeof value !== "number") {
                        return value;
                    }
                    var formatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    });
                    return formatter.format(value);
                },
                truncate: function (text, maxLength, addElipsis) {
                    if (typeof addElipsis === 'undefined') {
                        addElipsis = true;
                    }
                    if (text.length > maxLength) {
                        text = text.substring(0, maxLength);
                        if (addElipsis) {
                            text = text + '...';
                        }
                    }
                    return text;
                },
                formatDate: function (value, dateFormat) {
                    return moment(value).format(dateFormat);
                }
            },
            created: function () {
                this.setDefaultPage();
                this.initializeSort();
                this.initializeDatePicker();
                this.search();
                this.computeVacationsPerRow();
            },
            updated: function () {
                window.configurePhoneNumbers();
                window.slimmage.checkResponsiveImages();

                favorites.setFavoriteIcons();
                this.setupPopups();
                countdownTimer.initialize('#vacationSearchApp .countdown-timer-item');

                var $sortOptions = $('.filterSortResults input[name="sort-order"]');
                if (!_.isEqual(this.filterParams, window.vacationSearchParameters)) {
                    this.dirty = true;
                }
                var sortQuery = this.getQueryVariable("sort-order");
                console.info(sortQuery);
                if (!sortQuery && $sortOptions.length > 0 && this.sortOrder != $sortOptions[0].value) {
                    console.info("Found sort query: ", this.sortOrder, $sortOptions[0].value)
                    this.dirty = true
                }
                else if (sortQuery && this.sortOrder != sortQuery) {
                    console.info("Didn't find sort query: ", this.sortOrder);
                    this.dirty = true;
                }
            },
            mounted: function () {
                var $filterDropdowns = $('.dropdown.popdown-panel');
                $filterDropdowns.on('hide.bs.dropdown', function (e) {
                    if (event && 'isPrimary' in event && !event['isPrimary']) { /*console.log('hide.bs.dropdown - Non-primary event');*/ return false; }
                    if (!e || !e.target || !event) { /*console.log('hide.bs.dropdown - No target or event');*/ return; }
                    var menu = $(e.target).find('.dropdown-menu');
                    if (menu.length === 0) { /*console.log('hide.bs.dropdown - No menu');*/ return; }

                    var box = menu[0].getBoundingClientRect();
                    /*var prefix = 'hide.bs.dropdown - click=' + event.clientX + 'x' + event.clientY + ', box=' + box.left + '-' + box.right + 'x' + box.top + '-' + box.bottom + ' - ';*/
                    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) { /*console.log(prefix + 'Outside menu');*/ return; }
                    /*console.log(prefix + 'Inside menu');*/
                    return false;
                });

                var $filterInnerTabs = $filterDropdowns.find('a[data-toggle="tab"]');
                $filterInnerTabs.on('click', function (e) {
                    e.preventDefault();
                });

                $(window).on({
                    //'scroll': this.checkForNewPage,
                    'resize': this.handleWindowResize
                });
            },
            methods: {
                search: function () {
                    var self = this;

                    if (this.filterParams.isLmdSearch) {
                        vacationSearchService.lmdSearch(this.filterParams).then(function (data) {
                            self.vacations = data;
                            self.loading = false;
                            self.initialized = true;
                        });
                    }
                    else {
                        vacationSearchService.search(this.filterParams).then(function (data) {
                            self.vacations = data;
                            self.loading = false;
                            self.initialized = true;
                        });
                    }

                },
                showMore: function () {
                    this.pages += 1;
                },
                rememberPage: function () {
                    // add hash to url before linking, so when a user presses "back" in their browser, the page can load data from the hash
                    window.location.hash = this.pages + ',' + this.sortOrder;
                },
                setDefaultPage: function () {
                    var pageParts = (window.location.hash || ' ').substring(1).split(',');
                    var pageHash = parseInt(pageParts[0]);
                    if (!window.location.hash || isNaN(pageHash)) {
                        pageHash = 1;
                    }

                    if (pageParts.length > 1) {
                        this.sortOrder = pageParts[1];
                    }
                    else if (this.getQueryVariable("sort-order")) {
                        this.sortOrder = this.getQueryVariable("sort-order");
                    }

                    this.pages = pageHash;
                },
                initializeSort: function () {
                    if (!this.sortOrder || this.sortOrder === '') {
                        var $sortOptions = $('.filterSortResults input[name="sort-order"]');
                        this.sortOrder = $sortOptions.length > 0 ? $sortOptions[0].value : '';
                    }
                },
                initializeDatePicker: function () {
                    $daysToDropEl = $('[data-days-to-drop]');
                    this.daysToDrop = parseInt($daysToDropEl.data('days-to-drop'));
                    if (isNaN(this.daysToDrop)) {
                        this.daysToDrop = 0;
                    }

                    let currentDate = new Date();
                    currentDate.setDate(currentDate.getDate() + this.daysToDrop);
                    let startYear = currentDate.getFullYear();
                    let startMonth = currentDate.getMonth(); // zero indexed

                    // lmdType:1 represents the "LMD" type which is truly a "last minute deal"
                    // It doesn't make sense to display months beyond six months for a true LMD
                    let maxMonths = window.vacationSearchParameters.lmdType === 1 ? 36 - startMonth : 36 - startMonth;
                    let maxYears = 3;

                    let yearOptions = {};
                    let monthArr = [];
                    let yearCnt = 0;
                    for (let monthCnt = 0; monthCnt < maxMonths; monthCnt++) {
                        let wrappedMonth = (startMonth + monthCnt) % 12;
                        if (monthCnt > 0 && wrappedMonth === 0) {
                            yearOptions[startYear + yearCnt++] = monthArr;
                            monthArr = [];
                        }

                        monthArr.push(wrappedMonth);
                    }
                    if (monthArr.length > 0 && yearCnt < maxYears) {
                        yearOptions[startYear + yearCnt] = monthArr;
                    }

                    this.yearMonthOptions = monthYearPicker.initializeOptions({ enabledOptions: yearOptions });
                },
                toggleFavorite: function (favId) {
                    favorites.toggleFavorite(favId);
                    favorites.setFavoriteIcons();
                },
                handleWindowResize: function () {
                    var self = this;
                    self.computeVacationsPerRow();
                    //self.checkForNewPage();
                },
                computeVacationsPerRow: function () {
                    var orig = this.vacationsPerRow;
                    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
                    this.vacationsPerRow = viewportWidth > 1366 ? 3 : (viewportWidth > 922 ? 2 : 1);
                },
                checkForNewPage: function () {
                    if (!this.enableShowMore) return;

                    var showMore = $('a.load-more-results.outlineButton');
                    if (showMore.length === 0) return;

                    var box = showMore[0].getBoundingClientRect();
                    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                    if (box.top < 0 || box.bottom > (viewportHeight + 200)) return;

                    this.showMore();
                },
                getDealPromoBox: function (idx) {
                    var boxes = this.dealPromoBoxes.boxes;
                    var dealPromoBoxIdx = ((idx - this.dealPromoBoxes.startAt) / this.dealPromoBoxes.repeatAfter) % boxes.length;
                    // This works because if we try to index into the array with a fractional value, we get back undefined
                    return boxes[dealPromoBoxIdx];
                },
                regionUpdated: function (regionId) {
                    var self = this;
                    var checked = self.filterParams.w.indexOf(regionId) >= 0;
                    var countries = $('input[data-region="' + regionId + '"]');
                    if (checked) {
                        countries.each(function () { if (self.filterParams.w.indexOf(this.value) < 0) self.filterParams.w.push(this.value); });
                    } else {
                        countries.each(function () { var idx = self.filterParams.w.indexOf(this.value); if (idx >= 0) self.filterParams.w.splice(idx, 1); });
                    }

                    this.regionRelatedUpdated(regionId);
                },
                countryUpdated: function (regionId) {
                    var self = this;
                    var idx = self.filterParams.w.indexOf(regionId);
                    var allCountriesChecked = true;
                    var countries = $('input[data-region="' + regionId + '"]');
                    countries.each(function () { if (self.filterParams.w.indexOf(this.value) < 0) allCountriesChecked = false; });
                    if (allCountriesChecked && idx < 0) {
                        self.filterParams.w.push(regionId);
                    } else if (!allCountriesChecked && idx >= 0) {
                        self.filterParams.w.splice(idx, 1);
                    }

                    this.regionRelatedUpdated(regionId);
                },
                multiCountryUpdated: function (regionId) {
                    this.regionRelatedUpdated(regionId);
                },
                regionRelatedUpdated: function (regionId) {
                    var fp = this.filterParams;
                    var relateds = $('input[data-related-region="' + regionId + '"]');
                    var anyChecked = false;

                    for (var i = 0; i < relateds.length && !anyChecked; i++) {
                        var related = relateds[i];
                        if (!related || !related.name) return;

                        var arr = fp[related.name];
                        if ((typeof (arr) === 'boolean' && arr) || (typeof (arr) === 'object' && typeof (arr.indexOf) === 'function' && arr.indexOf(related.value) >= 0)) anyChecked = true;
                    }

                    var key = "r" + regionId;
                    if (this.filteredRegions[key] !== anyChecked) this.filteredRegions[key] = anyChecked;
                },
                clearDestination: function () {
                    if (this.filterParams.w.length > 0) this.filterParams.w.splice(0, this.filterParams.w.length);
                    if (this.filterParams.mc) delete this.filterParams.mc;
                    for (var key in this.filteredRegions) {
                        if (/^r[0-9]+$/.test(key)) {
                            this.filteredRegions[key] = false;
                        }
                    }
                },
                clearPrice: function () {
                    if (this.filterParams.c.length > 0) this.filterParams.c.splice(0, this.filterParams.c.length);
                },
                clearPace: function () {
                    if (this.filterParams.p.length > 0) this.filterParams.p.splice(0, this.filterParams.p.length);
                },
                clearStyle: function () {
                    if (this.filterParams.s.length > 0) this.filterParams.s.splice(0, this.filterParams.s.length);
                },
                clearDates: function () {
                    if (this.filterParams.m.length > 0) this.filterParams.m.splice(0, this.filterParams.m.length);
                    if (this.filterParams.d.length > 0) this.filterParams.d.splice(0, this.filterParams.d.length);
                },
                clearBrand: function () {
                    if (this.filterParams.o.length > 0) this.filterParams.o.splice(0, this.filterParams.o.length);
                },
                clearSort: function () {
                    var $sortOptions = $('.filterSortResults input[name="sort-order"]');
                    this.sortOrder = $sortOptions.length > 0 ? $sortOptions[0].value : '';
                },
                clearAll: function () {
                    this.clearDestination();
                    this.clearPrice();
                    this.clearPace();
                    this.clearDates();
                    this.clearBrand();
                    this.clearSort();

                    var $form = $('form.searchFilter');
                    if (window.location.pathname !== $form.attr('action') || (window.location.search && window.location.search.length > 1)) {
                        Vue.nextTick(function () {
                            $('form.searchFilter').submit();
                        });
                    }
                },
                formatDate: function (date) {
                    var fullDate = new Date(date);
                    var formattedDate = fullDate.toLocaleString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                    });

                    return formattedDate;
                },
                setupPopups: function () {
                    fancyBoxBySize.initialize(this.$el);
                },
                getQueryVariable: function (variable) {
                    var query = window.location.search.substring(1);
                    var vars = query.split('&');
                    for (var i = 0; i < vars.length; i++) {
                        var pair = vars[i].split('=');
                        if (decodeURIComponent(pair[0]) == variable) {
                            return decodeURIComponent(pair[1]);
                        }
                    }
                    console.log('Query variable %s not found', variable);
                }
            },
            watch: {
                async enableShowMore(newResult) {
                    if (newResult) {
                        await this.$nextTick();
                        if (this.pages > 1) {
                            $(window).scrollTop($('.deals-card-row').height() - 500);
                        }
                    }
                }
            },
        });

        setupSearchForm();
    });

    function setupSearchForm() {
        var $searchForm = $('form.searchFilter');
        var $submitButtons = $searchForm.find('.apply-search');
        var $mobileFilterButton = $('button.mobileFilterButton');
        var $popupClose = $('button.ft-mobile-close');

        $submitButtons.on('click', function () {
            var $this = $(this);
            if (!$this.hasClass('disabled')) {
                $submitButtons.addClass('disabled');
                var $form = $this.closest('form');

                var isFullVacationSearch = $form.hasClass('full-vacation-search');
                if (isFullVacationSearch) {
                    // Perform adjustments to url to map combinations of urls to shortened urls
                    adjustVacationSearchFormAction($form);
                }

                $form.submit();
            }
        });

        $mobileFilterButton.on('click', function () {
            var $popup = $(".ft-popup-wrap");
            $popup.toggleClass("active");
            if (document.documentElement.classList.contains('ft-popup-active')) {
                document.documentElement.classList.remove('ft-popup-active');
            }
            else {
                document.documentElement.classList.add('ft-popup-active');
            }
        });

        $popupClose.on('click', function () {
            var $popup = $(".ft-popup-wrap");
            $popup.removeClass("active");
            document.documentElement.classList.remove('ft-popup-active');
        });
    }

    function adjustVacationSearchFormAction($form) {
        var filterParameters = JSON.parse(JSON.stringify(window.vacationSearchParameters || {}));
        var vacationStyles = filterParameters.s;
        var countries = filterParameters.w;
        var $selectedCountries = $form.find('.country-input:checked');
        var $selectedVacationStyles = $form.find('.travel-style-input:checked');
        var newUrl = $form.attr('action');

        if ($selectedCountries.length <= 0 && $selectedVacationStyles.length <= 0) {
            // should default to the root vacation search page. No adjustments necessary
        }
        else if ($selectedCountries.length === 1 && (vacationStyles.length != 1 || $selectedVacationStyles.length != 1)) {
            newUrl = $selectedCountries.attr('data-action-url');
        }
        else if ($selectedVacationStyles.length === 1 && (countries.length != 1 || $selectedCountries.length != 1)) {
            newUrl = $selectedVacationStyles.attr('data-action-url');
        }
        else if ($selectedCountries.length > 1) {
            // If and only if ALL of the countries under a single region are checked, post to that region
            var regionId = $selectedCountries.attr('data-region');
            var $region = $form.find('input.region-input[value="' + regionId + '"]');
            var $allRegionCountries = $form.find('input.country-input[data-region="' + regionId + '"]');

            var allRegionCountryIds = _.map($allRegionCountries, function (country) {
                return country.value;
            });
            var selectedCountryIds = _.map($selectedCountries, function (country) {
                return country.value;
            });

            if (_.isEqual(selectedCountryIds, allRegionCountryIds)) {
                newUrl = $region.attr('data-action-url');
            }
        }

        $form.attr('action', newUrl + '#1,' + window.vacationSearchVue.sortOrder);
    }

})(jQuery)